import { gql } from '@apollo/client'

export const GET_E_PROFILE = gql`
  query getEProfile($patientId: String!) {
    getEProfile(patientId: $patientId) {
      patientId
      warnings {
        id
        type
        cause
        agent
        reaction
        risk
      }
      lifestyle {
        lastUpdated
        alcohol
        healthHabits
        smoking
        toxicImpacts
        medicationInfo
        diet
        typeOfWork
        exercise
      }
      cases {
        id
        title
        createdAt
        updatedAt
        status
      }
      medications {
        id
        name
        dosage
        severity
        doctor
        date
        isTakenNow
      }
      vaccinations {
        id
        code
        name
        date
      }
      surgeries {
        id
        name
        type
        date
      }
    }
  }
`
